import Color from 'color';

// Specify the colors for an item.
type ColorSpecification = {
  stroke: string; // Color of the stroke.
  strokeWidth: number; // Width of the stroke.
  fill: string; // Color of the fill.
  text: string; // Color of text.
};

// Inputs the color scheme uses to generate colors.
type ColorInputs = {
  n?: number; // The object number.
  total?: number; // The total number of objects.

  // Hierarchy diagrams.
  depth?: number; // The level in the hierarchy numbered from 0.

  // Shape based colors.
  shape?: string; // The shape of the object.
};

// Subclasses generate colors to apply to a diagam. Also implements the default
// colors.
//
// When generating colors the caller must pass in which color in the sequence
// they want, and the total number of colors they will request. This allows the
// color scheme to generate colors that are visually distinct from each other,
// and also spanning a range evenly.
class ColorScheme {
  static title = 'Default';
  static value = 'default';
  static swatchColors = ['#005CA9', '#FFA500', '#FF0000'];

  static objectColors = ['#005CA9'];
  static connectorColors = ['#FFA500'];
  static shapeColors: Record<string, string> = {};

  static objectColor(inputs: ColorInputs): ColorSpecification {
    /* if (inputs.n !== undefined) {
      return this.gradientColor(inputs, this.objectColors[0]);
    } else */
    if (inputs.depth) {
      return this.generateDepthColor(inputs, this.objectColors);
    } else if (inputs.shape) {
      return this.shapeColor(inputs);
    } else {
      return this.shapeColor(inputs);
    }
  }

  static connectorColor(inputs: ColorInputs): ColorSpecification {
    return this.generateDepthColor(inputs, this.connectorColors);
  }

  static shapeColor(inputs: ColorInputs): ColorSpecification {
    const shape = inputs.shape || 'roundRect';
    const baseColor = this.shapeColors[shape] || this.objectColors[0];

    return {
      stroke: baseColor,
      strokeWidth: 3,
      fill: Color(baseColor).mix(Color('white'), 0.92).hex(),
      text: baseColor,
    };
  }

  static generateDepthColor(
    inputs: ColorInputs,
    colors: string[]
  ): ColorSpecification {
    let depth = inputs.depth || 0;
    if (depth < 0) depth = 0;
    if (depth >= colors.length) depth = colors.length - 1;
    const baseColor = colors[depth];

    return {
      stroke: baseColor,
      strokeWidth: 3,
      fill: Color(baseColor).mix(Color('white'), 0.92).hex(),
      text: baseColor,
    };
  }

  static gradientColor(
    inputs: ColorInputs,
    baseColor: string
  ): ColorSpecification {
    const n = inputs.n || 0;
    const total = inputs.total || 1;
    const gradientColor = Color(baseColor)
      .lighten((0.7 * n) / total)
      .hex();

    return {
      stroke: gradientColor,
      strokeWidth: 3,
      fill: Color(gradientColor).mix(Color('white'), 0.92).hex(),
      text: gradientColor,
    };
  }
}

export type { ColorSpecification, ColorInputs };
export const DefaultColorScheme = ColorScheme;
export default ColorScheme;
